export default "__VITE_ASSET__DYW2vhfC__"